import { render, staticRenderFns } from "./AthleteAccessControlFormSlim.vue?vue&type=template&id=a2224fcc&scoped=true&"
import script from "./AthleteAccessControlFormSlim.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccessControlFormSlim.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteAccessControlFormSlim.vue?vue&type=style&index=0&id=a2224fcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2224fcc",
  null
  
)

export default component.exports